module.exports = __webpack_public_path__ + "static/img/page7_img7.fdfab5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img7.jpg
// module id = rkPh
// module chunks = 1